export default __webpack_public_path__ + "static/2-3bb8a29a760c78e3ea204e8f59cabb0b.svg";